import React from 'react';
import { NavLink } from 'react-router-dom';

import './nav.scss';

function Nav() {
  return (
    <nav className="nav">
      <NavLink className="nav-link" to="/game">
        Game
      </NavLink>
      <NavLink className="nav-link" to="/stats">
        Stats
      </NavLink>
    </nav>
  );
}

export default Nav;
